import React from 'react';
import { isMobile } from '@/utils';

function FosterApplyListService(props) {
  if (isMobile()) {
    const Mobile = require('./FosterApplyList').default;
    return <Mobile {...props} />;
  }
  const Web = require('./WebFosterApplyList').default;
  return <Web {...props} />;
}

export default FosterApplyListService;
